export const ACADEMIC_DEPARTMENTS = [
  // Life Sciences
  'Biology',
  'Biochemistry',
  'Biotechnology',
  'Neuroscience',
  'Genetics',
  'Microbiology',
  'Molecular Biology',

  // Physical Sciences
  'Physics',
  'Chemistry',
  'Astronomy',
  'Earth Sciences',
  'Atmospheric Sciences',

  // Engineering
  'Aerospace Engineering',
  'Biomedical Engineering',
  'Chemical Engineering',
  'Civil Engineering',
  'Computer Engineering',
  'Electrical Engineering',
  'Environmental Engineering',
  'Industrial Engineering',
  'Materials Science',
  'Mechanical Engineering',
  'Software Engineering',

  // Mathematics and Computer Science
  'Mathematics',
  'Applied Mathematics',
  'Computer Science',
  'Data Science',
  'Statistics',
  'Information Technology',

  // Medical Sciences
  'Medicine',
  'Dentistry',
  'Pharmacy',
  'Public Health',
  'Veterinary Science',

  // Social Sciences
  'Psychology',
  'Economics',
  'Sociology',
  'Political Science',
  'Anthropology',

  // Environmental Sciences
  'Environmental Science',
  'Ecology',
  'Marine Biology',
  'Conservation Biology',

  // Interdisciplinary Fields
  'Bioinformatics',
  'Nanotechnology',
  'Robotics',
  'Artificial Intelligence',
  'Quantum Computing',
  'Renewable Energy',
] as const;

export const DEPARTMENT_CATEGORIES = [
  'Sociology',
  'Public Affairs',
  'Political Science',
  'Psychology',
  'Economics',
  'Marketing',
  'Finance',
  'Accounting',
  'Operations',
  'Data Science',
  'Statistics',
  'Robotics',
  'Computer Science',
  'Artificial Intelligence',
  'Electrical Engineering',
  'Financial Engineering',
  'Mechanical Engineering',
  'Civil Engineering',
  'Architectural Engineering',
  'Environmental Engineering',
  'Aerospace Engineering',
  'Biomedical Engineering',
] as const;
